// @ts-ignore
import { /*loader,*/ gql } from "graphql.macro";

// http://localhost:8080/rest/values/values?nodes=6&method=SUM&units=metric&locale=de&startDate=1591914787
const values = gql`
  query values(
    # $nodes: String!
    $node: String!
    $startDate: String!
    $endDate: String!
    # $width: Long = 1000
    $method: String
    $units: String
    $locale: String
  ) {
    values(
      # nodes: $nodes
      node: $node
      startDate: $startDate
      endDate: $endDate
      # width: $width
      method: $method
      units: $units
      locale: $locale
    )
      @rest(
        # type: "DataSeries",
        type: "LiveDataValueItem"
        path: "livedata/values?{args}"
      ) {
      # tagId
      # label
      # data
      formattedValue
      rawValue
      unitSymbol
      method
      delayedDate
    }
  }
`;

export default values;
